export default __webpack_public_path__ + "static/media/priyam_mohanty.34281ba0.png";